import { createActionGroup, props } from '@ngrx/store'
import { ViewerPosition, ViewerState } from './viewer.state'
import { ViewerQueryParams } from '../../shared/model/query-params-types'
import { ImageInvlerpParameters } from 'neuroglancer/webgl/shader_ui_controls'

export const viewerActions = createActionGroup({
    source: 'Viewer',
    events: {
        'Config Loaded': props<{
            config: ViewerState | null
            queryParams: ViewerQueryParams
        }>(),
        'Set Zoom': props<{ zoom: number }>(),
        'Set Position': props<{ position: ViewerPosition }>(),
        'Set Expanded Nodes': props<{ expandedNodes: string[] }>(),
        'Set Favorite Layers': props<{ favoriteLayers: string[] }>(),
        'Set Layout': props<{ layout: 'xy' | 'xz' | 'yz' | undefined }>(),
        'Set Layer Name': props<{ name: string; newName: string }>(),
        'Set Layer Visibility': props<{ name: string; visible: boolean }>(),
        'Set Local Layer Visibility': props<{ id: string; visible: boolean }>(),
        'Set Layer List Dialog Open': props<{ open: boolean; layersChanged?: boolean }>(),
        'Sync Viewer Config': props<Record<string, never>>(),
        'Set Layer Opacity': props<{ name: string; opacity: number }>(),
        'Set Layer Opacity Unselected': props<{ name: string; opacity: number }>(),
        'Set Layer Saturation': props<{ name: string; saturation: number }>(),
        'Set Layer Shader Color': props<{ name: string; shaderColor: string }>(),
        'Set Layer Brightness': props<{ name: string; brightness: number }>(),
        'Set Layer Contrast': props<{ name: string; contrast: number }>(),
        'Set Layer Normalize': props<{ name: string; normalize: ImageInvlerpParameters }>(),
        'Set Layer Segmentation Color': props<{
            name: string
            segmentationColor: string | undefined
        }>(),
        'Set Search Key': props<{ searchKey: string }>(),
        'Delete Layer': props<{ name: string }>(),
        'Delete Selection': props<{ name: string }>(),
    },
})
